import { useAccountContext } from '@seek/hirer-graphql-react';
import { Hidden } from 'braid-design-system';

import { useQueryJobs } from 'src/hooks/useQueryJobs';
import { TabLoadTracker } from 'src/modules/events/TabLoadTracker';
import { IntercomConfiguration } from 'src/modules/intercom/IntercomConfiguration';

import { useQueryParam } from '../../../hooks/useQueryParam';
import { MainContent } from '../MainContent/MainContent';

import { JobListDesktopAndTablet } from './JobListDesktopAndTablet';
import { JobListMobile } from './JobListMobile';

export const JobsContent = () => {
  const { loading: loadingAccountInfo } = useAccountContext();

  const { loading: loadingJobs, error, totalCount, jobs } = useQueryJobs();
  const { tab } = useQueryParam();

  return (
    <MainContent
      error={error}
      loading={loadingAccountInfo || loadingJobs}
      totalCount={totalCount}
    >
      <TabLoadTracker jobs={jobs} />
      <IntercomConfiguration numberOfJobs={jobs.length} />

      <Hidden below="tablet">
        <JobListDesktopAndTablet jobs={jobs} tab={tab} />
      </Hidden>

      <Hidden above="mobile">
        <JobListMobile jobs={jobs} />
      </Hidden>
    </MainContent>
  );
};
